import { Accordion, AccordionTab } from 'primereact/accordion'
import React, { useEffect, useState } from 'react'
import EditEstimating from '../ESTIMATING/EditEstimating'
import EDIT_PM_TEMPLATE from './EDIT_PM_TEMPLATE'
import EDIT_INTERIOR_DESIGN_TEMPLATE from '../INTERIOR DESIGN TEMPLATE/EDIT_INTERIOR_DESIGN'
import { useNavigate, useParams } from 'react-router-dom';
import { Api } from '../../../services/api'
import WARRANTY from '../WARRANTY/WARRANTY'
import JOB_AUTOPSY from '../JOB AUTOPSY/JOB_AUTOPSY'
import { Button } from 'primereact/button'
import { FaCopy, FaSync } from 'react-icons/fa'
import DEVELOPMENT_MANAGER_TEMPLATE from '../DEVELOPMENT MANAGER TEMPLATE/DEVELOPMENT_MANAGER_TEMPLATE'

import { TabView, TabPanel } from 'primereact/tabview';
import ConstructionAndInterior from '../CONSTRUCTION AND INTERIOR/ConstructionAndInterior'
import { IoArrowBackSharp } from 'react-icons/io5'
import EDIT_SP_TEMPLATE from './EDIT_SP_TEMPLATE'

const EDIT_All_PLAYBOOKS = () => {
   const navigate = useNavigate();
   const { proId } = useParams();
   const { pmTeId } = useParams();
   const [projectName, setProjectName] = useState('');
   useEffect(() => {
      // setIsLoading(false);
      getProjectDetails();


      return () => {
         // Cleanup tasks before the component is unmounted
      };
   }, []);

   const getProjectDetails = () => {
      // fetch.

      var _body = {

         projectId: proId,
      }
      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
         'Content-Type': 'application/json',
         'Authorization': token ? `Bearer ${token}` : ''
      };
      fetch(Api.API_BASE_URL + 'template/get-project-for-template', {
         method: "POST",

         body: JSON.stringify(_body),
         headers: headers
      })
         .then((response) => response.json())
         .then((response) => {


            setProjectName(response.project_name);
         })
         .catch((error) => {
            // setIsLoading(false);
            console.error("Error:", error);
         });
   }

   const archiveProject = () => {
      // fetch.

      fetch(Api.API_BASE_URL + 'all-template/archive-all-project/' + proId, {
         method: "GET",


      })
         .then((response) => response.json())
         .then((response) => {

         })
         .catch((error) => {
            // setIsLoading(false);
            console.error("Error:", error);
         });
   }

   return (
      <>
         <div className="p-2" style={{ height: '88vh', overflowY:'hidden' }}>
            <div className='m-4 my-2 flex one-line-container'>
               <button type='button' onClick={() => { navigate(-1); window.close(); }} className='customSave-button m-2 flex'>
                  <IoArrowBackSharp className='text-sm' />
                  <span>Back</span>
               </button>
               <div>
                  <p> Project Address: <strong>{projectName}</strong></p>
               </div>
               <div>
                  <Button className="m-2 p-2 copySave-button" onClick={() => window.location.reload()} type="button" title="Refresh Page">
                     <FaSync />
                  </Button>
               </div>
            </div>


            <TabView multiple   >
               <TabPanel header={<span className="tab-header-wrap">DEVELOPMENT MANAGER</span>} className="accordian-header m-1">
                  <DEVELOPMENT_MANAGER_TEMPLATE pmId={proId} />
               </TabPanel>

               <TabPanel header={<span className="tab-header-wrap">PRE CONSTRUCTION MANAGER</span>} className="accordian-header m-1">
                  <EditEstimating ProjectIdEdit={proId} />
               </TabPanel>

               <TabPanel header={<span className="tab-header-wrap">SUPERINTENDENT CONSTRUCTION</span>} title='Superintendent Construction' className="accordian-header m-1">
                  <EDIT_SP_TEMPLATE pmId={proId} />
               </TabPanel>

               <TabPanel header={<span className="tab-header-wrap">CONSTRUCTION MANAGER</span>} className="accordian-header m-1">
                  <EDIT_PM_TEMPLATE pmId={proId} />
               </TabPanel>

               <TabPanel header={<span className="tab-header-wrap">INTERIOR DESIGNER</span>} className="accordian-header m-1">
                  <EDIT_INTERIOR_DESIGN_TEMPLATE pmId={proId} />
               </TabPanel>

               <TabPanel header={<span className="tab-header-wrap">CONSTRUCTION MANAGER & INTERIOR DESIGNER</span>} className="accordian-header m-1">
                  <ConstructionAndInterior pmId={proId} />
               </TabPanel>

               <TabPanel header={<span className="tab-header-wrap">JOB AUTOPSY</span>} className="accordian-header m-1">
                  <JOB_AUTOPSY pmId={proId} />
               </TabPanel>

               <TabPanel header={<span className="tab-header-wrap">WARRANTY</span>} className="accordian-header m-1">
                  <WARRANTY pmId={proId} />
               </TabPanel>

            </TabView>
         </div>

      </>
   )
}

export default EDIT_All_PLAYBOOKS